import { h, render } from 'preact'
import { useState, useEffect } from 'preact/hooks'
import { memo } from 'preact/compat'
import { useSize } from 'utils/dom'

function MegaDropdown({ items, cssClass }) {
    return (
        <div className="modal-content">
            <div className={`columns ${cssClass}`}>
                {items.map(item => (
                    <ul key={item.id} className="sublist lvl-0">
                        <li>
                            {(item.url||item.seName)
                                ? (<a href={item.url || item.seName}>{item.title}</a>)
                                : (<span>{item.title}</span>)}
                        
                            {item.subItems.length > 0 && (
                                <ul className="sublist lvl-1">
                                    {item.subItems.map(subItem => (
                                        <li key={subItem.id}><a href={subItem.url || subItem.seName}>{subItem.title}</a></li>
                                    ))}
                                </ul>
                            )}
                        </li>
                    </ul>
                ))}
            </div>
        </div>
    )
}

function MegaMenuItem({
    id,
    openInNewWindow,
    subItems,
    title,
    type,
    seName,
    url,
    cssClass,
    active,

    onClearActiveItems,
    onSetDropdownItems,
    onSetCssClass,
    ...rest
}) { 
    const handleClick = (e) => {
        // follow link 
        if (!subItems.length > 0) {
            return;  
        }

        e.preventDefault();

        // Unset active on other items
        onClearActiveItems()

        // Tilt the chevron down for this item
        e.target.parentElement.classList.add('active')

        // Add css classes from menu builder
        onSetCssClass(cssClass)

        // Swap out sub categories
        onSetDropdownItems(subItems.length > 0 ? subItems : [])

        // Close other drawers
        window._drawerManager.closeAllExcept('menu')
    }

    return (<li>
        {(url || seName) ? (
            <a href={url || seName} onClick={handleClick} rel={openInNewWindow ? "noreferrer" : ""} target={openInNewWindow ? "_blank" : "_self"}>
                {title}

                {subItems?.length > 0 && (
                    <svg className="topmenu-catalog-chevron" width="18" height="18" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.36612 16.1161C7.87796 16.6043 7.87796 17.3957 8.36612 17.8839L23.1161 32.6339C23.6043 33.122 24.3957 33.122 24.8839 32.6339L39.6339 17.8839C40.122 17.3957 40.122 16.6043 39.6339 16.1161C39.1457 15.628 38.3543 15.628 37.8661 16.1161L24 29.9822L10.1339 16.1161C9.64573 15.628 8.85427 15.628 8.36612 16.1161Z" fill="var(--md-gray-950)"></path></svg>
                )}
            </a>
        ) : (
            <span role='button' tabIndex={0} onClick={handleClick}>
                {title}
                
                {subItems?.length > 0 && (
                    <svg className="topmenu-catalog-chevron" width="18" height="18" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.36612 16.1161C7.87796 16.6043 7.87796 17.3957 8.36612 17.8839L23.1161 32.6339C23.6043 33.122 24.3957 33.122 24.8839 32.6339L39.6339 17.8839C40.122 17.3957 40.122 16.6043 39.6339 16.1161C39.1457 15.628 38.3543 15.628 37.8661 16.1161L24 29.9822L10.1339 16.1161C9.64573 15.628 8.85427 15.628 8.36612 16.1161Z" fill="var(--md-gray-950)"></path></svg>
                )}
            </span>
        )}
    </li>)
}

function MegaMenu() {
    // initial data from server side render
    const megaMenu = window.CRITICAL_STATE.menu.megaMenus[0]

    // elements to use
    const backdrop = document.querySelector('.modal-overlay')
    const modalMenu = document.querySelector('#modal-menu');

    // component state
    const [dropdownItems, setDropdownItems] = useState([])
    const [currentCssClass, setCurrentCssClass] = useState('')

    // sets current css class, from admin ui for each menu
    const onSetCssClass = cssClass => setCurrentCssClass(cssClass)

    // remove chevron rotations
    const clearActiveLinks = () => {
        const topLevelMenuItems = Array.from(document.querySelectorAll('.menu-categories > li'))

        if (topLevelMenuItems.length > 0) {
            topLevelMenuItems.map(li => li.classList.toggle('active', false))
        }
    }

    // update dropdown items
    const onSetDropdownItems = (items) => {
        // The user clicked the same menu item twice
        if (items === dropdownItems) {
            setDropdownItems([])
            clearActiveLinks()
            window._drawerManager.closeAll()
            return; 
        }

        setDropdownItems(items)
    }

    // clear state
    const clear = () => {
        setDropdownItems([])
        clearActiveLinks()
    }

    // on mount interactions
    useEffect(() => {
        backdrop.addEventListener('click', clear);

        // reset state when user presses the back button in the browser
        window.addEventListener("pageshow", () => {
            clear();
        });
    }, [])

    // listen to new dropdown items
    useEffect(() => {
        // dont do anything 
        if (!dropdownItems.length) return; 

        // Disable other modals with app instance
        window._drawerManager.open('menu')

        // re-render the dropdown menu with new items & possibly a new css class
        render(
            <MegaDropdown items={dropdownItems} cssClass={currentCssClass} />,
            modalMenu,
        );
    }, [dropdownItems])

    return (
        <ul className={`menu-categories ${currentCssClass}`}>
            {megaMenu.items.map(item => (
                <MegaMenuItem
                    {...item}
                    key={item.id}
                    active={dropdownItems == item.subItems}
                    onSetDropdownItems={onSetDropdownItems}
                    onSetCssClass={onSetCssClass}
                    onClearActiveItems={clearActiveLinks}
                />
            ))}
        </ul>
    );
}

export default memo(MegaMenu);